import request from '@/utils/request';

// 登录
export function login(account, pwd) {
  return request({
    url: '/v1/auth/portal/login',
    method: 'post',
    data: {
      phone: account,
      password: pwd
    }
  });
}

// 登出
export function logout() {
  return request({
    url: '/v1/auth/portal/logout',
    method: 'post'
  });
}

/**
 *   刷新token
 * @method refreshToken
 * @return { request } axsio请求封装
 */
export function refreshToken(refreshToken) {
  return request({
    url: `/op/user/refresh`,
    method: 'get',
    params: { refreshToken }
  });
}

/**
 *   统一登录
 */
export function getUserSso() {
  return request({
    url: `/v1/auth/portal/sso`,
    method: 'post'
  });
}

